import type { CSSProperties } from 'react';
import { mergeStyles } from '../../../helper/UtilityFunctions';
import classes from './Text.module.scss';

type TextProps = {
  style?: CSSProperties[] | CSSProperties;
  className?: string;
  children?: React.ReactNode;
};

export function Text(props: TextProps) {
  let effectiveStyles;

  if (Array.isArray(props.style)) {
    effectiveStyles = mergeStyles(props.style);
  } else {
    effectiveStyles = props.style;
  }

  let effectiveClassName = classes.Text;

  if (props.className) {
    effectiveClassName += ` ${props.className}`;
  }

  return (
    <div className={effectiveClassName} style={effectiveStyles}>
      {props.children}
    </div>
  );
}
